// components/TimeSpentLineChart.js

import React, { useState } from "react";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register chart components
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

const TimeSpentLineChart = () => {
    const [unit, setUnit] = useState("Min"); // Toggle state: "Min" or "Hr"

    // Sample data in minutes
    const minutesData = {
        labels: ["", "", "", "", "", "", "", "", "", "", "", ""],
        datasets: [
            {
                label: "Article 1",
                data: [85, 70, 40, 50, 40, 45, 50, 60, 50, 15, 35, 55],
                borderColor: "#5C6AC4",

            },
            {
                label: "Article 2",
                data: [12, 20, 30, 65, 85, 80, 10, 15, 10, 15, 20, 30],
                borderColor: "#EC4899",

            },

        ],
    };

    // Convert minutes to hours if needed
    const chartData = {
        ...minutesData,
        datasets: minutesData.datasets.map((dataset) => ({
            ...dataset,
            data: unit === "Hr" ? dataset.data.map((val) => (val / 60).toFixed(2)) : dataset.data,
        })),
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
            tooltip: {
                enabled: true, // ❌ Turn off tooltip if you also don't want hover values
            },
            datalabels: {
                display: false, // ⛔ Explicitly disable data labels if plugin is registered
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 30,
                    callback: function (value) {
                        return value; // or " sec" if you're using seconds
                    }
                },
            },

        }
    };

    return (
        <div style={{ textAlign: "right" }}>
            <div style={{ marginBottom: "20px" }}>
                <button
                    onClick={() => setUnit("Min")}
                    style={{
                        padding: "8px 16px",
                        marginRight: "10px",
                        background: unit === "Min" ? "#4F46E5" : "#E5E7EB",
                        color: unit === "Min" ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                    }}
                >
                    Min
                </button>
                <button
                    onClick={() => setUnit("Hr")}
                    style={{
                        padding: "8px 16px",
                        background: unit === "Hr" ? "#4F46E5" : "#E5E7EB",
                        color: unit === "Hr" ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                    }}
                >
                    Hr
                </button>
            </div>
            <Line data={chartData} options={options} />
        </div>
    );
};

export default TimeSpentLineChart;
